import React, { Component } from 'react';
import { connect } from 'react-redux';
import { patient as actions } from '../actions';
import { Patient } from '../components';
import moment from 'moment';

@connect((state) => ({
  patientData: state.patient
}))
export default class PatientPage extends Component {
  
  componentDidMount() {
    const { dispatch, patientData } = this.props;
    const patientId = 1;
    const patient = patientData.get('patientsById').get(patientId);
    if ( !patient ) {
      dispatch(actions.loadPatient(patientId));
    } else {
      this.day = moment().diff(moment(patient.get('createdAt')), 'days') + 1;
    }
  }

  componentWillReceiveProps(nextProps) {
    const { patientData } = nextProps;
    const patientId = 1;
    const patient = patientData.get('patientsById').get(patientId);
    if ( patient ) {
      this.day = moment().diff(moment(patient.get('createdAt')), 'days') + 1;
    }
  }

  render() {
    const patientId = 1;
    const patient = this.props.patientData.get('patientsById').get(patientId);
    return (
      <Patient patient={patient}
               day={this.day}/>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/patient.js